import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useEffect } from "react";
import { Plus } from "lucide-react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import CourseListTabs from "@/components/menu-management/course/course-list/course-list-tabs";
import DraftListTabs from "@/components/menu-management/course/course-list/draft-list-tabs";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllCourses,
  clearCourseMessages,
} from "@/redux/slice/menu-manage-slice/courses-slice";
import { clearItemVariants } from "@/redux/slice/essential-menu-slice/variants-slice";
import useAuth from "@/hooks/useAuth";
import TableSkeleton from "@/components/skeleton/table-skeletion";
import hasPermission from "@/hooks/hasPermission";

function Course() {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const { getLoading, requestStatus, error } = useSelector(
    (state) => state.menuManage.course
  );

  useEffect(() => {
    dispatch(fetchAllCourses(user.restaurant_id));
    dispatch(clearCourseMessages());
    dispatch(clearItemVariants());
  }, [user.restaurant_id]);

   if (getLoading) return <TableSkeleton links={backofficeLinks} />
  return (
    <Layout2
     pageName={{ title: "Course List" }}
      paths={[
        { name: "home", path: "/home" },
        { name: "Back Office", path: "/backoffice/overview" },
        { name: "Menu Management", path: "/backoffice/menu/drinks" },
        { name: "Course", path: "/backoffice/menu/drinks" },
      ]}
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
    >
      <div className="container flex flex-col gap-4 mt-5">
   <div className="flex justify-end items-start md:items-center md:flex-row flex-col  w-full">
        
          {hasPermission("back_office.menu_management.create_course") && (
            <Link to={"/backoffice/menu/course/create"}>
              <Button>
                <Plus /> Create Course
              </Button>
            </Link>
          )}
        </div>
        <Tabs valueKey="menu-course" className="bg-transparent relative" defaultValue="drink">
          <TabsList className="grid grid-cols-6 w-full">
            <Separator className="absolute top-8 " />
            <TabsTrigger className="bg-transparent" value="drink">
              Course List
            </TabsTrigger>
            <TabsTrigger value="draft">Draft List</TabsTrigger>
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          <CourseListTabs />
          <DraftListTabs />
        </Tabs>
      </div>
    </Layout2>
  );
}

export default Course;
